<script lang="ts" setup>
import { computed } from 'vue'

import { StructureTermItem, StructureTermList } from '@toni/brand-ui'

import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'structureTermTree')

</script>

<template>
  <StructureTermList class="gap-[20px] py-6 sm:columns-2 md:columns-3 md:py-8">
    <StructureTermItem v-for="(tagItem, index) in contentBlock.data.structureTermTree"
                       :key="`tag-item-${index}`"
                       :tag-item="tagItem"
                       :level="0" />
  </StructureTermList>
</template>
